import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=35bf6a5f"
import script from "./ListSkeleton.vue?vue&type=script&lang=js"
export * from "./ListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=35bf6a5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
